import classes from "./Navbar.module.css";
import logo from "../../assests/img/bmps-rmbg.png";
import Switcher from "../switcher/Switcher";
import { Link } from "react-router-dom";

const Navbar = ({ darkSide, toggleDarkMode }) => {
  console.log("ddd", darkSide);
  return (
    <div
      className={
        darkSide === true
          ? classes["nav-container-dark"]
          : classes["nav-container"]
      }
    >
      <div className={classes["nav"]}>
        <div
          className={`${
            darkSide === true ? classes["dark-p"] : classes["light-p"]
          } ${classes["nav-flex"]}`}
        >
          <div className="relative">
            <div>
              <div className={classes["logo"]}>
                <img src={logo} alt="" />
              </div>
            </div>
            <p className="absolute top-3 w-56 left-16 font-bold">
              BMPS Learning Myanmar
            </p>
          </div>
          <div className={classes["searchcontainer"]}>
            <div className={classes["search"]}>
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 512 512"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
              </svg>
              <input
                type="text"
                placeholder="Discover news, articles and more..."
                aria-label="Search"
                className={classes["css-16pntcr"]}
              ></input>
            </div>
          </div>
          <div className={classes["nav-item-container"]}>
            <div className={classes["nav-item"]}>
              <div className={classes["nav-item-flex"]}>
                <Link to="/">
                  <div className={classes["nav-item-link"]}>Home</div>
                </Link>
                <Link to="authors">
                  <div className={classes["nav-item-link"]}>Authors</div>
                </Link>
                <div className={classes["nav-item-link"]}>Courses</div>
                {/* <div className={classes["switch-btn"]}>
                  <div className={classes["switch"]}>
                    <button
                      aria-label="Toggle dark mode"
                      type="button"
                      role="switch"
                      aria-checked="true"
                      className={classes["rc-switch css-cqu7wq rc-switch-checked"]}
                    >
                      <span className={ca["rc-switch-inner"]}>
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          class="css-uk6cul"
                          height="16"
                          width="16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"></path>
                        </svg>
                      </span>
                    </button>
                  </div>
                </div> */}
                <div className={classes["nav-item-link"]}>
                  <Switcher
                    toggleDarkMode={toggleDarkMode}
                    darkSide={darkSide}
                  />
                  {/* <label
                    for="default-toggle"
                    class="inline-flex relative items-center cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      value=""
                      id="default-toggle"
                      class="sr-only peer"
                    />
                    <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                  </label> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
